module.exports = __webpack_public_path__ + "static/img/pricetitle.d0496d6f.jpg";